/** Dashboard rules (SELL-01, MERCH-58). Pure: no I/O. */

/** A store with no orders yet: every trend month is zero and no order has a status. */
export function hasNoOrders(summary) {
  if (!summary) return false;
  const trend = summary.trend || [];
  const breakdown = summary.status_breakdown || [];
  return trend.every((t) => !Number(t.sales_paise) && !Number(t.orders)) && breakdown.every((b) => !Number(b.count));
}

/** Checklist items to show: open ones first (in registry order), then done ones. */
export const checklistOrder = (items = []) => [...items.filter((i) => !i.done), ...items.filter((i) => i.done)];
